import { useAtom, useSetAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { postCollectionStateFamily, loadMorePostsAtom, PostCollectionCompositeKeyParams, PostCollectionType } from '../posts';
export interface UsePaginatedPostsPayload {
    tokenName: string;
    fetchLimit?: number;
    type: PostCollectionType;
    flairId?: string;
    userId?: string;
}

export const usePaginatedPosts = (payload: UsePaginatedPostsPayload) => {
    const { tokenName, userId, fetchLimit = 20, flairId, type } = payload;

    const params: PostCollectionCompositeKeyParams = useMemo(() => ({
        type,
        tokenName,
        ...flairId && { flairId }, // Conditionally add flairId
        ...userId && { userId },   // Conditionally add userId
    }), [type, tokenName, flairId, userId]);

    const [collectionState] = useAtom(postCollectionStateFamily(params));
    const triggerLoadMore = useSetAtom(loadMorePostsAtom);

    const loadMore = useCallback(async () => {
        if (collectionState.status === 'loading' || !collectionState.hasMore) return false

        try {
            await triggerLoadMore({ ...params, fetchLimit });
            return true;
        } catch (e) {
            console.error('Error triggering loadMorePostsAtom:', e);
            return false;
        }
    }, [collectionState.status, collectionState.hasMore, triggerLoadMore, params, fetchLimit]);

    return {
        postIds: collectionState.ids,
        loadMore,
        hasMore: collectionState.hasMore,
        loadStatus: collectionState.status,
        error: collectionState.error,
    };
};